import { render, staticRenderFns } from "./imodal.vue?vue&type=template&id=4156b216&scoped=true&"
import script from "./imodal.vue?vue&type=script&lang=js&"
export * from "./imodal.vue?vue&type=script&lang=js&"
import style0 from "./imodal.vue?vue&type=style&index=0&id=4156b216&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4156b216",
  null
  
)

export default component.exports